import BillingCategoryBaseController from "../common/billing_category.base.controller"

class BillingCategoryEditController extends BillingCategoryBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BillingCategoryService, $q) {

        super(Auth, $state, User, BillingCategoryService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillingCategoryService = BillingCategoryService;
        this.$q = $q;

        this.defaultModel = {
            isCreate: false,
            branchId: User.getUser().branchId,
            name: null,
            description: null,
            status: true,
            errorMessage: '',
            generalLedgerCode: null,
        }

        this.model = angular.copy(this.defaultModel);
    }

    $onInit() {
        this.Service.get(this.$stateParams.id)
            .then((data) => {
                this.defaultModel = data;
                this.rawId = data.id;
                this.model.id = data.id;
                this.model.name = data.name;
                this.model.description = data.description;
                this.model.status = data.status;
                this.model.generalLedgerCode = data.generalLedgerCode;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
    }

    update() {
        this.model.isUpdating = true;
        delete this.model.errorMessage;

        this.Service.update(this.$stateParams.id, {
            name: this.model.name,
            description: this.model.description,
            status: this.model.status,
            branchId: this.model.branchId,
            generalLedgerCode: this.model.generalLedgerCode
        })
            .then(() => {
                window.history.go(-1);
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isUpdating = false;
            })
    }
}

export default BillingCategoryEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/edit/billing_category.edit.controller.js